import Alpine from 'alpinejs';
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/blur-up/ls.blur-up';
import AcfHelper from "./_acf";

window.Alpine = Alpine;

document.addEventListener("DOMContentLoaded", () => {
    Alpine.start();
    require("./utils/menu");
    require("./utils/smooth-scroll");
    require("./utils/_animations");

    if (document.querySelector(".gform_fileupload_multifile")) {
        require("./utils/upload-input");
    }

    const openModal = document.querySelectorAll(".js-open-modal");
    openModal.forEach(el => {
        el.addEventListener("click", () => {
            const videos = document.querySelectorAll(".js-video");
            if (videos) {
                videos.forEach(video => {
                    video.setAttribute("src",video.getAttribute('data-src'));
                });
            }
        });
    });

});

AcfHelper.handleInit("text-image", () => {
    Alpine.start();
});
